/**
 * Email template icon stored as S3 URL vs legacy emoji / empty.
 */
export const isRemoteEmailTemplateIcon = (icon) =>
  typeof icon === "string" && /^https?:\/\//i.test(icon.trim());
